type TopographicLinesProps = {
  className?: string;
};

export function TopographicLines({ className = "" }: TopographicLinesProps) {
  return (
    <svg
      className={`topographic-lines ${className}`}
      viewBox="0 0 420 300"
      fill="none"
      aria-hidden="true"
    >
      <path d="M-18 280C40 228 29 169 94 142c62-26 94 24 156-14 52-31 45-87 102-109 30-12 57-7 85 7" />
      <path d="M-15 263c48-39 47-95 107-115 57-20 89 25 148-7 58-32 50-91 112-111 30-10 56-2 82 10" />
      <path d="M-10 245c42-32 53-83 101-94 55-13 90 28 142 1 57-30 60-92 118-109 29-9 53-1 79 13" />
      <path d="M-7 225c37-25 49-65 95-71 51-6 88 28 135 7 52-24 67-87 123-104 28-8 51 1 75 15" />
      <path d="M-3 205c30-18 47-50 88-49 46 1 82 28 128 12 51-18 72-79 126-96 26-8 50 2 72 16" />
      <path d="M0 184c27-13 45-34 81-26 40 9 77 28 119 17 50-13 77-69 129-88 24-9 47 1 68 14" />
      <path d="M6 162c23-8 42-19 73-7 35 14 72 29 111 22 47-8 78-55 129-74 22-9 43-1 63 11" />
      <path d="M14 139c21-4 38-3 64 11 31 18 66 30 103 28 46-2 76-39 124-57 23-9 42-3 61 8" />
    </svg>
  );
}

